import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/major'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(major) {
    return http.post(`${resource}`, major)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(major, uuid) {
    return http.put(`${resource}/${uuid}?_method=PATCH`, major)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },

}
